var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-button',{attrs:{"type":"primary"},on:{"click":_vm.retrySimCardCarrierTasks}},[_vm._v("重跑")])}
var staticRenderFns = []

export { render, staticRenderFns }